module.exports = __webpack_public_path__ + "static/media/lifestyle4-large.225943b3.jpg";